<template>
  <div id="app">
    <find-stats />
    <find-modal v-if="page === PAGE_UNSUPPORTED">
      <find-unsupported />
    </find-modal>
    <find-modal v-if="page === PAGE_WELCOME">
      <find-welcome />
    </find-modal>
    <find-modal wide v-if="page === PAGE_CONGRATULATIONS">
      <find-congratulations />
    </find-modal>
    <find-game v-if="page === PAGE_GAME" />
    <find-footer />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import {
  PAGE_CONGRATULATIONS,
  PAGE_GAME,
  PAGE_UNSUPPORTED,
  PAGE_WELCOME,
} from 'constants';

import Congratulations from 'components/Congratulations.vue';
import Footer from 'components/Footer.vue';
import Game from 'components/Game.vue';
import Modal from 'components/Modal.vue';
import Stats from 'components/Stats.vue';
import Unsupported from 'components/Unsupported.vue';
import Welcome from 'components/Welcome.vue';

export default {
  components: {
    'find-congratulations': Congratulations,
    'find-footer': Footer,
    'find-game': Game,
    'find-modal': Modal,
    'find-stats': Stats,
    'find-unsupported': Unsupported,
    'find-welcome': Welcome,
  },
  data: () => ({
    PAGE_CONGRATULATIONS,
    PAGE_GAME,
    PAGE_UNSUPPORTED,
    PAGE_WELCOME,
  }),
  computed: mapState({
    page: state => state.page,
  }),
  methods: mapActions([
    'setPage',
  ]),
};
</script>

<style lang="scss">
:root {
  background: #eee;
  font-family: Roboto, sans-serif;
  height: 100%;
  overflow-x: hidden;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  margin: 0;
}

a {
  color: #44c;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

svg {
  width: 100%;
}
</style>



/** WEBPACK FOOTER **
 ** App.vue?37f9c9fd
 **/